var _a, _b, _c, _d, _e;
import logger from '../lib/logger';
export var APP_CONFIG_URL = 'https://assets.skland.com/common-config/json/app-config.json';
export var IS_RN = false;
export var IS_APP = false;
export var IS_PC = false;
try {
    // IS_RN
    if ((navigator === null || navigator === void 0 ? void 0 : navigator.product) === 'ReactNative') {
        IS_RN = true;
    }
    else if ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) === null || _a === void 0 ? void 0 : _a.includes('ReactNative')) {
        IS_RN = true;
    }
    // IS_APP
    var userAgent = (_b = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    if (userAgent === null || userAgent === void 0 ? void 0 : userAgent.includes('skland'))
        IS_APP = true;
    // IS_PC
    try {
        document.createEvent('TouchEvent');
    }
    catch (e) {
        IS_PC = true;
    }
}
catch (error) {
    logger.error(error.message);
}
// TIP: IS_IOS 和 IS_ANDROID 互斥
export var IS_IOS = false;
export var IS_IOS9 = false;
export var IOS_VERSION = -1;
export var IS_ANDROID = false;
export var ANDROID_VERSION = -1;
export var APP_VERSION = '';
try {
    var userAgent = (_c = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) === null || _c === void 0 ? void 0 : _c.toLowerCase();
    // IS_IOS
    if (/mac|iphone|ipad|ipod|ios/i.test(userAgent))
        IS_IOS = true;
    // IS_ANDROID
    if (/android|adr|linux|xiaomi/i.test(userAgent)) {
        IS_ANDROID = true;
        IS_IOS = false;
    }
    // IS_IOS9
    if (IS_IOS) {
        var version = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        if (version === null || version === void 0 ? void 0 : version[1]) {
            IS_IOS9 = Number.parseInt(version[1], 10) < 9;
            IOS_VERSION = Number.parseInt(version[1], 10);
        }
    }
    else if (IS_ANDROID) {
        var str = userAgent.match(/android (.*?);/);
        if (str === null || str === void 0 ? void 0 : str[1])
            ANDROID_VERSION = parseInt(str[1]);
    }
    // APP_VERSION
    var result = userAgent === null || userAgent === void 0 ? void 0 : userAgent.match(/skland\/([\d|.]+)/);
    if (result)
        APP_VERSION = result[1];
}
catch (error) {
    logger.error(error.message);
}
export var IS_WECHAT = false;
export var IS_WEIBO = false;
export var IS_BAIDU = false;
export var IS_QQ = false;
export var IS_QQ_BROWSER = false;
export var IS_QQ_ZONE = false;
try {
    var userAgent = (_d = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) === null || _d === void 0 ? void 0 : _d.toLowerCase();
    // @ts-ignore
    if (/micromessenger/i.test(userAgent) || typeof (navigator === null || navigator === void 0 ? void 0 : navigator.wxuserAgent) !== 'undefined')
        IS_WECHAT = true;
    IS_WEIBO = /weibo/i.test(userAgent);
    IS_BAIDU = /baidu/i.test(userAgent);
    IS_QQ = /qq/i.test(userAgent);
    IS_QQ_BROWSER = /qqbrowser/i.test(userAgent);
    IS_QQ_ZONE = /qzone/i.test(userAgent);
}
catch (error) {
    logger.error(error.message);
}
export var IS_SAFARI = false;
try {
    var userAgent = (_e = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) === null || _e === void 0 ? void 0 : _e.toLowerCase();
    if (IS_IOS && /safari/i.test(userAgent)) {
        if (navigator.vendor && navigator.vendor === 'Apple Computer, Inc.') {
            IS_SAFARI = true;
        }
    }
}
catch (error) {
    logger.error(error.message);
}
